import React from 'react';
import { ChevronLeft } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { useChatsContext } from '../ChatsContext';

export default function BackToChatsLink() {
  const { chatRootPath } = useChatsContext();
  return (
    <IconButton component={Link} to={chatRootPath}>
      <ChevronLeft />
    </IconButton>
  );
}
